const SliderData = [
    // {
    //     slider_id: 1,
    //     slider_img: './images/slider/slider01.jpg',
    //     slider_link: '/template/E31/intro', //如果需要連到faq: faq/campaign-preview-link/feature-preview-online
    //     slider_template_element: 'E31',
    //     slider_template_title: '体育明星',
    //     slider_template_category_name: '体育模版',
    //     //如果需要連到faq, 則要在這邊填寫參數，參數對應 大分類的category_id
    //     category_id: 0
    // },
    {
        slider_id: 1,
        slider_img: './images/slider/slider02.jpg',
        slider_link: '/template/E20/intro',
        slider_template_element: 'E20',
        slider_template_title: '金球入门',
        slider_template_category_name: '趣味模版',
        //for faq link
        category_id: 0
    },
    {
        slider_id: 2,
        slider_img: './images/slider/slider03.jpg',
        slider_link: '/template/E29/intro',
        slider_template_element: 'E29',
        slider_template_title: '新年火箭',
        slider_template_category_name: '节庆模版',
        //for faq link
        category_id: 0
    }
];

export default SliderData;
